import React from 'react'
import useStyles from './styles'
import { WidgetContentHyperlink } from 'data/Show'

interface WidgetTitleProps {
    heading: string
    subHeading?: string
    hyperlink?: WidgetContentHyperlink
}

const WidgetTitle: React.FC<WidgetTitleProps> = ({ heading, subHeading, hyperlink }) => {
    const classes = useStyles()
    return (
        <div className={classes.headingContainer}>
            <p className={classes.heading}>{heading}</p>
            <div className={classes.subHeadingContaner}>
                <p className={classes.subHeading}>{subHeading}</p>
                {hyperlink?.url && (
                    <a className={classes.hyperlink} href={hyperlink.url} target="_blank" rel="noopener noreferrer">
                        {hyperlink.text}
                    </a>
                )}
            </div>
        </div>
    )
}

export default React.memo(WidgetTitle)
